import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extraído de core/store/effects.ts em 27/08/2026 pra ser reaproveitado
 * pelos effects de módulos feature (ex.: FinanceiroModule) sem duplicar.
 *
 * status 0 é o que o Angular reporta para falhas de rede/DNS/CORS (o request
 * nem chegou a um servidor) — comum neste esqueleto enquanto os endpoints
 * placeholder (ver src/environments/endpoints.ts) não apontarem para uma
 * rota real confirmada.
 *
 * `error.error?.erro` — CONFIRMADO em 24/08/2026 testando ao vivo contra o
 * backend real (`Administradora/ParametrosCompletos` sem token retornou
 * `{"erro": "..."}`): este backend usa `{ erro }` em português, minúsculo,
 * não o `{message}`/`{title}` padrão do ASP.NET.
 *
 * `typeof error.error === 'string'` — CONFIRMADO em 25/08/2026: alguns
 * endpoints (`PossuiSenhaExterna` com data de nascimento em formato errado)
 * respondem TEXTO PURO (`"Data de nascimento inválida"`), não JSON. O
 * `HttpClient` (responseType padrão `'json'`) falha ao fazer parse disso e
 * embrulha o corpo de um jeito que não bate com nenhuma das chaves acima —
 * sem esse checáveis extra, a mensagem real do backend nunca chegava até o
 * usuário, só o fallback genérico.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    if (error.status === 0) {
      return 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.';
    }
    if (typeof error.error === 'string' && error.error.trim()) {
      return error.error;
    }
    if (error.error?.erro) {
      return error.error.erro;
    }
    if (error.error?.message) {
      return error.error.message;
    }
    if (error.error?.title) {
      return error.error.title;
    }
  }
  return fallback;
}
